firebird.factory('videoDeviceService', [
    '$window',
    'logService',
    'attendeeService',
    'connectivityService',
    'helperService',
    'avDeviceService',
    'storageService',
    'supportLinkService',
    'brandingService',
    'localizationService',
    'videoGlobalService',
    'localStreamManagerService',
    'socketService',
    'executionEnvironmentEnum',
    'configService',
    function (
        $window,
        logService,
        attendeeService,
        connectivityService,
        helperService,
        avDeviceService,
        storageService,
        supportLinkService,
        brandingService,
        localizationService,
        videoGlobalService,
        localStreamManagerService,
        socketService,
        executionEnvironmentEnum,
        configService
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = logService.createLoggerWithSource('[videoroomCtrl] videoDeviceService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.getDeviceTimeoutSwalOptions = getDeviceTimeoutSwalOptions;

            self.showDeviceInUseAlert = showDeviceInUseAlert;

            self.selectedVideoInput = null;
            self.selectedAudioInput = null;

            self.updateLocalAudioState = updateLocalAudioState;

            // willSwitchDevice + avDeviceService.setIsMicrophoneDeviceSwitching are used for prevent appearing red exclamation mark when switching microphone
            self.willSwitchDevice = false;
            self.onFinishedMediaDeviceSelection = onFinishedMediaDeviceSelection;
            self.onFinishedAudioDeviceConnect = onFinishedAudioDeviceConnect;
            self.updateAudioInputDevice = updateAudioInputDevice;
            self.updateAudioOutputDevice = updateAudioOutputDevice;

            self.reconnectAudioInput = reconnectAudioInput;
            self.deviceUpdateEventToMsgFlow = deviceUpdateEventToMsgFlow;
            self.onLogDeviceChange = onLogDeviceChange;

            // when audio video state is updated in node server
            $scope.$on('update-local-audio-state', updateLocalAudioState);
            $scope.$on('update-local-video-state', updateLocalVideoState);

            // device selection and permission
            $scope.$on('finished-media-device-selection', onFinishedMediaDeviceSelection);

            $scope.$on('sfu-audio-device-reconnection', onFinishedAudioDeviceConnect);
            $scope.$on('sfu-video-device-reconnection', onFinishedVideoDeviceConnect);

            $scope.$on('phone-state-updated', onPhoneStateUpdated);
            $scope.$on('sfu-sip-connected', onSipConnected);
            $scope.$on('sfu-sip-remote-sdp-applied', onSipConnected);
            $scope.$on('sfu-sip-media-state', onSipMediaState);

            $scope.$on('update-audio-output', self.updateAudioOutputDevice);
            $scope.$on('reconnect-audio-input', self.reconnectAudioInput);
            $scope.$on('log-device-change', self.onLogDeviceChange);
            $scope.$on('alert-device-in-use', onShowDeviceInUseAlert);
            $scope.$on('send-msgflow-event', onSendMsgFlowEvent);
        }

        function getDeviceTimeoutSwalOptions() {
            var supportLink = supportLinkService.getSupportLink('manageDevices');
            var title = localizationService.translate(
                'HEADER.PERMISSIONS_ERROR.COMMON.PROBLEM_ACCESSING_DEVICE_HEADER'
            );
            var msg = localizationService.translate('HEADER.PERMISSIONS_ERROR.COMMON.PROBLEM_ACCESSING_DEVICE', {
                link: supportLink
            });
            var confirmBtnText = localizationService.translate('COMMON.OKAY_TEXT');
            var swalOptions;
            var closeButtonHtmlDeviceAccessProblem =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
            swalOptions = {
                title: closeButtonHtmlDeviceAccessProblem + title,
                text: msg,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: confirmBtnText,
                confirmButtonColor: brandingService.getBaseColor(),
                allowOutsideClick: false,
                html: true,
                imageUrl: 'img/redesign/modal/pop-up-pic-warning.svg'
            };

            return swalOptions;
        }

        function onShowDeviceInUseAlert(e, data) {
            const { device, deviceIds = [], showHowToFix = true } = data;
            showDeviceInUseAlert(device, deviceIds, showHowToFix);
        }

        function showDeviceInUseAlert(device, deviceIds = [], showHowToFix = true) {
            var alert;
            switch (device) {
                case 'microphone':
                    alert = localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_MICROPHONE');
                    break;
                case 'webcam':
                    alert = localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_WEBCAM');
                    break;
                case 'microphone and webcam':
                    alert = localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_MICROPHONE_WEBCAM');
                    break;
                default:
                    alert = localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_WEBCAM');
            }
            const deviceNames = Array.isArray(deviceIds)
                ? deviceIds
                      .map(id => avDeviceService.getDeviceLabelFromId(id))
                      .filter(id => Boolean(id) && typeof id === 'string') // filter out any non-string values
                      .join(' and ')
                : '';
            const deviceLabel = deviceNames ? '<br><h4>' + deviceNames + '</h4><br>' : '';
            const howToFix = showHowToFix
                ? localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_HOW_TO_FIX')
                : '';
            self.showAlert(alert, deviceLabel + howToFix, true);
        }

        function updateLocalAudioState() {
            var currentLocalTrack;
            // for mediapath of 'sfu' use video stream (videoroom plugin), otherwise use audio stream (SIP plugin).
            var mystream = self.mediapath == 'sfu' ? self.mystream : self.mystream1;
            if (mystream && mystream.getAudioTracks() && mystream.getAudioTracks()[0]) {
                currentLocalTrack = mystream.getAudioTracks()[0];
            }

            self.updateConnTimeDevice();

            if (connectivityService.getAudioThroughPhone() || avDeviceService.isAudioDisconnected()) {
                if (self.mediapath != 'sfu' && self.VDIRef?.detachAudioTrackOnSwitchToPhone) {
                    detachSipAudioTrack();
                    self.cdrAudioEnabled = false;
                    return;
                }
                if (mystream && currentLocalTrack && currentLocalTrack.readyState === 'live') {
                    logger.log('videoroomCtrl switched-to-phone, stopping audio track');
                    if (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix) {
                        // On Citrix, cloning stream before stop so that the attendee is able to join the meeting even if no active stream is present.
                        var clonedStream = mystream.clone();
                        if (clonedStream && clonedStream.getAudioTracks() && clonedStream.getAudioTracks()[0]) {
                            clonedStream.getAudioTracks()[0].enabled = false;
                        }
                    }
                    mystream.getAudioTracks()[0].stop();
                }

                // this flag is used for audioEnabled or not, beyond just CDR.
                self.cdrAudioEnabled = false;
                return;
            }

            if (self.detachedSipAudio) {
                if (self.detachedSipAudio.pc === getSipPeerConnection()) {
                    reattachSipAudioTrack();
                    return;
                }
                // SIP call was recreated since the detach; nothing to re-attach to.
                self.detachedSipAudio = null;
            }

            if (currentLocalTrack && currentLocalTrack.readyState === 'ended') {
                //Sometimes when switched to phone, when unplugging an audio device,
                //storageService will still keep reference to that unplugged device's id
                //
                //calling determineMicAndCamAvailability will check the current devices to keep storageService up-to-date

                logger.log('videoroomCtrl switched-to-mic, checking device availability');
                avDeviceService
                    .determineMicAndCamAvailability()
                    .catch(function (err) {
                        logger.error('updateLocalAudioState', 'switched-to-mic error', err);
                    })
                    .finally(function () {
                        logger.log('videoroomCtrl switched-to-mic, updating audio input device');
                        self.updateAudioInputDevice('switch-to-mic audio-change');
                    });
            }

            var enable = !attendeeService.getIsAudioMuted();
            logger.log('videoroomCtrl update local audio state: ' + (enable ? 'unmuted' : 'muted'));

            // since audio is published via the SIP plugin.
            try {
                if (mystream) {
                    mystream.getAudioTracks()[0].enabled = enable;
                } else {
                    logger.warn(
                        'updateLocalAudioState',
                        'cannot change audio track enabled because mystream was not set'
                    );
                }
            } catch (e) {
                logger.warn('updateLocalAudioState', 'failed to change audio track enabled', e);
            }

            self.cdrAudioEnabled = enable;
            self.cdrAudioChanged = true;
        }

        function getSipPeerConnection() {
            return self.sipcall && self.sipcall.webrtcStuff ? self.sipcall.webrtcStuff.pc : undefined;
        }

        // 'accepted' is set in videoVoiceCallService before setRemoteDescription resolves; janus.js fills
        // webrtcStuff.remoteSdp only once it has (and clears it on cleanup).
        function isSipCallNegotiated() {
            return !!(
                self.sipcall &&
                self.sipcall.state &&
                self.sipcall.state.call === 'accepted' &&
                self.sipcall.webrtcStuff &&
                self.sipcall.webrtcStuff.remoteSdp
            );
        }

        // VDI (Omnissa): neither track.stop() nor track.enabled reach the Thin Client, so the only way to
        // silence the SIP leg is to take the track off its sender. Restoring the same track is rejected by
        // the SDK, hence reattachSipAudioTrack acquires a fresh one.
        // The SDK only forwards replaceTrack to the Thin Client when it is a real change on a negotiated
        // connection: a replaceTrack(null) issued before the offer (onlocalstream) leaves the proxy's
        // sender.track null while the Thin Client still publishes the mic, and a second replaceTrack(null) on
        // that sender is a no-op. So the detach is deferred until the call is negotiated, and `force` (used when
        // Janus reports our audio while we should be silent) re-attaches a fresh track first so the following
        // replaceTrack(null) is a real change again.
        function detachSipAudioTrack(force) {
            var pc = getSipPeerConnection();
            if (!pc) {
                return;
            }
            if (!isSipCallNegotiated()) {
                logger.log('detachSipAudioTrack', 'SIP call not negotiated yet, deferring detach');
                return;
            }

            // Keyed on the sender's current track, not on a "done" flag: an ICE restart (createOfferForSIP with
            // replaceAudio) puts a fresh mic track back on the same sender, which must be detached again.
            var senders = pc.getSenders();
            var alreadyDetachedForThisPc = !!self.detachedSipAudio && self.detachedSipAudio.pc === pc;
            var sender = senders.find(function (s) {
                return s.track && s.track.kind === 'audio';
            });
            if (sender) {
                replaceSipAudioTrackWithNull(pc, sender, false);
                return;
            }
            if (force && alreadyDetachedForThisPc) {
                forceRedetachSipAudioTrack(pc, self.detachedSipAudio.sender);
                return;
            }
            if (!alreadyDetachedForThisPc) {
                logger.warn('detachSipAudioTrack', 'no SIP audio sender to detach');
            }
        }

        function replaceSipAudioTrackWithNull(pc, sender, forced) {
            logger.log(
                'videoroomCtrl switched-to-phone, detaching audio track from SIP sender (VDI)' +
                    (forced ? ' [forced re-detach]' : '')
            );
            var seq = nextSipAudioOp();
            self.detachedSipAudio = { pc: pc, sender: sender };
            // may run inside a Janus callback; a sync throw here would abort the rest of stream setup
            var detachResult;
            try {
                detachResult = sender.replaceTrack(null);
            } catch (err) {
                detachResult = Promise.reject(err);
            }
            return Promise.resolve(detachResult).catch(function (err) {
                logger.error('detachSipAudioTrack', 'replaceTrack(null) failed', err);
                if (isCurrentSipAudioOp(seq)) {
                    self.detachedSipAudio = null;
                }
            });
        }

        // Detach, forced re-detach and re-attach each span async steps; a newer operation invalidates the
        // continuations of the older one so they cannot undo it.
        function nextSipAudioOp() {
            self.sipAudioOpSeq = (self.sipAudioOpSeq || 0) + 1;
            return self.sipAudioOpSeq;
        }

        function isCurrentSipAudioOp(seq) {
            return seq === self.sipAudioOpSeq;
        }

        // Proxy says detached but the Thin Client still sends: put a fresh track on the sender and take it
        // off again so the SDK forwards a real change.
        function forceRedetachSipAudioTrack(pc, sender) {
            if (self.forcingSipAudioDetach) {
                return;
            }
            self.forcingSipAudioDetach = true;
            var seq = nextSipAudioOp();
            logger.warn('detachSipAudioTrack', 'forcing re-detach via fresh track (VDI)');

            var media = self.getMediaConstraints('audio');
            $window.navigator.mediaDevices
                .getUserMedia({ audio: media.audio || true, video: false })
                .then(function (stream) {
                    var track = stream.getAudioTracks()[0];
                    if (!isCurrentSipAudioOp(seq) || pc !== getSipPeerConnection() || !shouldSilenceSipAudio()) {
                        stopTracks(stream);
                        return;
                    }
                    return sender
                        .replaceTrack(track)
                        .then(function () {
                            if (!isCurrentSipAudioOp(seq) || pc !== getSipPeerConnection()) {
                                logger.log('detachSipAudioTrack', 'superseded during forced re-detach, leaving sender');
                                return;
                            }
                            return replaceSipAudioTrackWithNull(pc, sender, true);
                        })
                        .finally(function () {
                            stopTracks(stream);
                        });
                })
                .catch(function (err) {
                    logger.error('detachSipAudioTrack', 'forced re-detach failed', err);
                })
                .finally(function () {
                    self.forcingSipAudioDetach = false;
                });
        }

        function reattachSipAudioTrack() {
            var detached = self.detachedSipAudio;
            self.detachedSipAudio = null;
            var seq = nextSipAudioOp();

            var media = self.getMediaConstraints('audio');
            logger.log('videoroomCtrl switched-to-mic, re-attaching fresh audio track to SIP sender (VDI)');

            $window.navigator.mediaDevices
                .getUserMedia({ audio: media.audio || true, video: false })
                .then(function (stream) {
                    if (!isCurrentSipAudioOp(seq)) {
                        logger.log(
                            'reattachSipAudioTrack',
                            'superseded while getUserMedia was pending, dropping fresh track'
                        );
                        stopTracks(stream);
                        return;
                    }
                    if (detached.pc !== getSipPeerConnection()) {
                        // SIP call changed while getUserMedia was pending; its own onlocalstream handles audio.
                        logger.log('reattachSipAudioTrack', 'SIP call changed, dropping fresh track');
                        stopTracks(stream);
                        return;
                    }
                    if (shouldSilenceSipAudio()) {
                        // switched back to phone/no audio while getUserMedia was pending; keep the sender detached
                        logger.log('reattachSipAudioTrack', 'back on phone/no audio, dropping fresh track');
                        stopTracks(stream);
                        self.detachedSipAudio = self.detachedSipAudio || detached;
                        return;
                    }

                    var track = stream.getAudioTracks()[0];
                    return detached.sender.replaceTrack(track).then(
                        function () {
                            if (!isCurrentSipAudioOp(seq) || detached.pc !== getSipPeerConnection()) {
                                logger.log(
                                    'reattachSipAudioTrack',
                                    'superseded while re-attaching, dropping fresh track'
                                );
                                stopTracks(stream);
                                return;
                            }
                            if (shouldSilenceSipAudio()) {
                                // flipped back to phone/no audio during replaceTrack; take the fresh track off again
                                return replaceSipAudioTrackWithNull(detached.pc, detached.sender, false).finally(
                                    function () {
                                        stopTracks(stream);
                                    }
                                );
                            }
                            self.mystream1 = stream;
                            localStreamManagerService.replaceLocalAudioTrack(track);
                            // keep local audio-level tracking (talking while muted, bad mic) on the live mic
                            localStreamManagerService.setClonedAudioStream(stream);
                            self.updateLocalAudioState();
                        },
                        function (err) {
                            stopTracks(stream);
                            throw err;
                        }
                    );
                })
                .catch(function (err) {
                    if (!isCurrentSipAudioOp(seq) || detached.pc !== getSipPeerConnection()) {
                        logger.warn('reattachSipAudioTrack', 'failed after being superseded, nothing to recover', err);
                        return;
                    }
                    if (shouldSilenceSipAudio()) {
                        // back on phone/no audio: the mic is not needed now; keep the marker so the next switch retries
                        logger.warn('reattachSipAudioTrack', 'failed while on phone/no audio, keeping detached', err);
                        self.detachedSipAudio = self.detachedSipAudio || detached;
                        return;
                    }
                    logger.error('reattachSipAudioTrack', 'failed, rejoining to recover audio', err);
                    self.rejoinConferenceIfNeeded('VDI mic switch');
                });
        }

        function stopTracks(stream) {
            try {
                stream.getTracks().forEach(function (track) {
                    track.stop();
                });
            } catch (e) {
                logger.warn('stopTracks', 'failed to stop tracks', e);
            }
        }

        function updateLocalVideoState() {
            var enable = attendeeService.getIsVideoMuted() ? false : true;
            logger.log('videoroomCtrl update local video state: ' + (enable ? 'unvmuted' : 'vmuted'));

            // since video is published via the video room plugin.
            try {
                // if video feed is stopped, then no video track present.
                self.mystream.getVideoTracks()[0].enabled = enable;
                if (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix) {
                    // Required to stop webcam light when webcam stream is turned off
                    if (!enable) {
                        self.mystream.getVideoTracks()[0].stop();
                    }
                }
            } catch (e) {}
        }

        function onFinishedAudioDeviceConnect(e, data) {
            logger.log('videoroomCtrl onFinishedAudioDeviceConnect...', data);

            self.updateAudioOutputDevice();
            self.updateAudioInputDevice('deviceReconnect audio-change');
        }

        function onFinishedVideoDeviceConnect(e, data) {
            //This function is specifically called as part of the device reconnection flow logic
            // as such, it doesn't check the muted state because that will be reset by the calls below.
            // This allows us active fallback to an available camera
            logger.log('videoroomCtrl onFinishedVideoDeviceConnect...', data);

            self.setInitialBitrate();

            self.stopVideoPublish();
            self.startVideoPublish();
        }

        //the event that triggers this essentially means the mic webcam options dialog has closed
        function onFinishedMediaDeviceSelection(e, data) {
            logger.log('videoroomCtrl onFinishedMediaDeviceSelection...', data);

            if (data && data.usePhoneForAudio !== undefined) {
                logger.log('videoroomCtrl Setting new audioThroughPhone value:', data.usePhoneForAudio);
                connectivityService.setAudioThroughPhone(data.usePhoneForAudio, true);
            }

            if (avDeviceService.isAudioDisconnected()) {
                connectivityService.disconnectAudioInputAndOutput(true);
            }

            if (data && data.newAudioOutputDeviceSelected) {
                self.updateAudioOutputDevice();
            }

            self.setInitialBitrate();

            // ANYAM-72965: webcam was unplugged and then plugged in and selected in AM settings
            // need to rejoin conference to see webcam in recording
            // Note: video is muted when new webcam connected
            let rejoiningConference = false;
            if (avDeviceService.getIsNewVideoDeviceConnected()) {
                logger.log('onFinishedMediaDeviceSelection', 'Webcam connected, rejoin the meeting');
                avDeviceService.setIsNewVideoDeviceConnected(false);

                if (!data || !data.joinMeeting) {
                    rejoiningConference = true;
                    self.rejoinConferenceIfNeeded('Webcam connected');
                }
            }

            if (data && (data.newVideoInputDeviceSelected || data.newAudioInputDeviceSelected)) {
                self.deviceUpdateEventToMsgFlow('device-select', {
                    audio: data.newAudioInputDeviceSelected,
                    video: data.newVideoInputDeviceSelected
                });
                if (!rejoiningConference && data.newVideoInputDeviceSelected && !attendeeService.getIsVideoMuted()) {
                    // //TODO: following is better but does not work in removing/adding
                    // //video track when simulcast is enabled. see related issue ANYAM-13288
                    // var mediaVideo = self.getMediaConstraints('video');
                    // mediaVideo.replaceVideo = true;
                    // self.videoroom.createOffer({
                    //     media: mediaVideo,
                    //     simulcast: self.simulcast,
                    //     success: function(jsep) {
                    //         logger.log('videoroomCtrl videoroom got publisher SDP!');
                    //         logger.log(jsep);
                    //         var publish = { 'request': 'configure', 'audio': true, 'video': true, 'bitrate': self.getVideoBitrate() };
                    //         self.videoroom.send({'message': publish, 'jsep': jsep});
                    //     },
                    //     error: function(error) {
                    //         logger.error('onFinishedMediaDeviceSelection', 'videoroom publisher WebRTC error', error);
                    //     }
                    // });

                    // Instead remove and add the videoroom participant.
                    self.stopVideoPublish();
                    self.startVideoPublish();
                }

                if (data.newAudioInputDeviceSelected) {
                    self.updateAudioInputDevice('audio-change');
                    //If mic changes, running enumerateDevices is needed to
                    //iterate through the device list and make sure the proper BT Audio Output is selected
                    avDeviceService.enumerateDevices('mic-changes').catch(function (err) {
                        logger.error('onFinishedMediaDeviceSelection', 'Failed to detect mic changes', err);
                    });
                }
            } else if (data && data.joinMeeting) {
                logger.log('videoroomCtrl joining meeting from initial device selection modal');
                self.joinConference();
            }
        }

        function updateAudioInputDevice(reason) {
            if (self.sipcall) {
                // last parameter is either reason string or true.
                self.msgflowEvent('peer-connection:device', {
                    type: 'audio',
                    reason: reason || 'audio input device change'
                });

                var deviceChange = reason || true;

                if (reason === 'audio-change') {
                    self.willSwitchDevice = true;
                }

                if (self.mediapath == 'sfu') {
                    self.createOfferOrRepublish(
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        deviceChange ? 'audio-change' : 'audio'
                    );
                } else {
                    self.createOfferForSIP(false, false, deviceChange);
                }
            } else {
                logger.log('videoroomCtrl ignoring updateAudioInputDevice, as no sip call');
            }
        }

        // Update the sink of the audio element based on the stored audio-output-device id.
        // Note: after calling setSinkId on a specific media element every other media element also started to use the same device for output.
        // This is why changing the audio output device works even for the mediapath 'sfu'.
        // https://stackoverflow.com/questions/48318007/setsinkid-change-muliple-audio-ouputs/48329464#48329464
        function updateAudioOutputDevice(retryCounter = 0) {
            const maxRetries = 2; // Maximum number of retries for Citrix SDK v4.0 including the initial attempt.

            try {
                logger.log('videoroomCtrl updateAudioOutputDevice');

                var audioElement = $window.$('#videoroom-sipaudio')[0];
                logger.log('videoroomCtrl updateAudioOutputDevice: sinkId before=' + audioElement.sinkId);

                //Clear sinkId before setting new val
                audioElement
                    .setSinkId('')
                    .catch(function (err) {
                        logger.error('updateAudioOutputDevice', 'Error clearing sinkid', err);
                    })
                    .finally(function () {
                        var audioOutputDeviceId = getAudioOutputDeviceId();
                        if (audioOutputDeviceId) {
                            logger.log('videoroomCtrl updateAudioOutputDevice: ', audioOutputDeviceId);
                            audioElement
                                .setSinkId(audioOutputDeviceId)
                                .catch(function (err) {
                                    logger.error(
                                        'updateAudioOutputDevice',
                                        'Error set sinkid',
                                        audioOutputDeviceId,
                                        err
                                    );
                                    // If the setSinkId fails, retry it for Citrix SDK v4.0.
                                    if (helperService.isCitrixSDKVersionFour()) {
                                        if (retryCounter < maxRetries) {
                                            logger.log(
                                                'updateAudioOutputDevice',
                                                'Retry setSinkId Citrix SDK, attempt:',
                                                retryCounter + 1
                                            );
                                            updateAudioOutputDevice(retryCounter + 1);
                                        } else {
                                            logger.warn(
                                                'updateAudioOutputDevice',
                                                'Max retry attempts reached, giving up'
                                            );
                                        }
                                    }
                                })
                                .finally(function () {
                                    logger.log(
                                        'videoroomCtrl updateAudioOutputDevice: sinkId after=' + audioElement.sinkId
                                    );
                                });
                            // crossbrowser compatibility check.
                            // firefox requires users to explicitly enable this feature in about:config media.setsinkid.enabled
                        } else {
                            logger.log('videoroomCtrl updateAudioOutputDevice: no audioOutputDeviceId');
                        }
                    });
            } catch (err) {
                logger.log('videoroomCtrl Unable to set sink Id: ', err);
            } finally {
                // If the audio element is not playing, it will not be able to play audio when the sinkId is set.
                // This is a workaround for Citrix SDK v2.0 where the audio stream is not auto-played when srcObject is set.
                // The audioElement.play() needs to be called to ensure the audio plays correctly.
                if (self.VDIRef?.getVdiType() === executionEnvironmentEnum.Citrix) {
                    logger.log('videoroomCtrl audioElement: play');
                    audioElement.play();
                }
            }
        }
        function getAudioOutputDeviceId() {
            const storedDeviceId = storageService.get('audio-output-device');

            if (storedDeviceId === 'communications') {
                const communicationsDevice = avDeviceService.speakers.find(d => d.deviceId === 'communications');
                return communicationsDevice?.originalId || storedDeviceId;
            }

            return storedDeviceId;
        }

        function reconnectAudioInput() {
            logger.log('videoroomCtrl reconnectAudioInput');
            self.updateAudioInputDevice('deviceReconnect audio-change reconnect-after-device-error');
        }

        function onPhoneStateUpdated() {
            self.updateLocalAudioState();
        }

        // The detach is issued once the SIP call is negotiated (see detachSipAudioTrack), and re-issued if Janus
        // still reports our audio RTP while we are supposed to be silent.
        function shouldSilenceSipAudio() {
            return (
                self.mediapath != 'sfu' &&
                !!self.VDIRef?.detachAudioTrackOnSwitchToPhone &&
                (connectivityService.getAudioThroughPhone() || avDeviceService.isAudioDisconnected())
            );
        }

        // Runs on 'sfu-sip-connected' (sync, before the answer is applied — detaches only on the early-media path
        // where the remote SDP is already in) and on 'sfu-sip-remote-sdp-applied' (after setRemoteDescription).
        function onSipConnected() {
            if (shouldSilenceSipAudio()) {
                detachSipAudioTrack(true);
            }
        }

        function onSipMediaState(e, data) {
            if (!data || data.medium !== 'audio' || !data.on) {
                return;
            }
            if (shouldSilenceSipAudio()) {
                logger.warn('onSipMediaState', 'Janus receiving our audio while on phone/no audio; re-detaching');
                detachSipAudioTrack(true);
            }
        }

        // audio and video are either true/false or an object with trackId
        function deviceUpdateEventToMsgFlow(event, { audio, video }) {
            const deviceInfo = {};
            if (audio) {
                let deviceId = storageService.get('audio-device');
                deviceInfo.audio = {
                    ...audio,
                    deviceId: deviceId,
                    label: avDeviceService.getLabelForDeviceId(deviceId, 'audioinput')
                };
            }
            if (video) {
                let deviceId = storageService.get('video-device');
                deviceInfo.video = {
                    ...video,
                    deviceId: deviceId,
                    label: avDeviceService.getLabelForDeviceId(deviceId, 'videoinput')
                };
            }
            self.msgflowEvent(event, deviceInfo);
            logger.log('deviceUpdateEventToMsgflow', event, deviceInfo);
        }

        function onLogDeviceChange(e, change) {
            if (!change) {
                self.msgflowEvent('no-device-change');
            } else if (change == 'in-progress' || change == 'in-timer') {
                self.msgflowEvent('instant-device-change', { reason: change });
            } else {
                self.msgflowEvent('device-change', change);
            }
        }

        function onSendMsgFlowEvent(e, event) {
            if (event?.name) {
                self.msgflowEvent(event.name, event.data);
            }
        }
    }
]);
